/* eslint-disable react/prop-types */
import React from 'react'
import TweenOne from 'rc-tween-one'
import SvgMorphPlugin from 'rc-tween-one/lib/plugin/SvgMorphPlugin'

TweenOne.plugins.push(SvgMorphPlugin)

const Radar =
  ({ style = {} }) =>
  () => {
    const { color = '#1173CB', height = 40, width = 40 } = style
    const dmeter = height || width
    const radio = dmeter / 2
    const d = `M ${radio}, ${radio} m -${radio}, 0 a ${radio}, ${radio} 0 1, 0 ${dmeter},0 a ${radio}, ${radio} 0 1, 0 -${dmeter},0`
    return (
      <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <TweenOne
          animation={{
            d,
            repeat: -1,
            duration: 400,
            repeatDelay: 450,
            opacity: '0.1',
            style: { fill: color }
          }}
          style={{ fill: color }}
          component='path'
          d='M 16, 16 m -8, 0 a 8, 8 0 1, 0 16,0 a 8, 8 0 1, 0 -16,0'
          attr='attr'
        />

        <circle cx={radio} cy={radio} r='8' fill={color} />
      </svg>
    )
  }

export default Radar
